import React from 'react';

import Edit from '@material-ui/icons/Edit';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import DomainIcon from '@material-ui/icons/Domain';
import HistoryIcon from '@material-ui/icons/History';
import SettingsIcon from '@material-ui/icons/Settings';
import SecurityIcon from '@material-ui/icons/Security';
import TransformIcon from '@material-ui/icons/Transform';
import EventNoteIcon from '@material-ui/icons/EventNote';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';

import PersonIcon from '../assets/images/svgIcons/userIcon';
import AssignmentIcon from '../assets/images/svgIcons/clients';
import MlScanIcon from '../assets/images/svgIcons/mlScanIcon';
import DashboardIcon from '../assets/images/svgIcons/dashboard';
import PlatformIcon from '../assets/images/svgIcons/platformIcon';
import EventLogIcon from '../assets/images/svgIcons/eventLogIcon';
import InsertDriveFileIcon from '../assets/images/svgIcons/software';
import IPFirewallIcon from '../assets/images/svgIcons/ipFirewallIcon';
import PlatformIconNew from '../assets/images/svgIcons/platformIconNew';
import SyslogSettingsIcon from '../assets/images/svgIcons/syslogSettings';
import IntelligentModelIcon from '../assets/images/svgIcons/intelligentModelIcon';
import UserManagementIcon from '../assets/images/svgIcons/userManagementIcon';

import SunIcon from './subMneuIcon/SunIcon';
import Dropdown from './subMneuIcon/dropdown';
import CrashIcon from './subMneuIcon/CrashIcon';
import LicenseTemp from './subMneuIcon/licenseTemp';
import SystemEvent from './subMneuIcon/SystemEvent';
import SystemSetting from './subMneuIcon/SystemSetting';
import ManageUserIcon from './subMneuIcon/ManageUserIcon';
import CreateUserIcon from './subMneuIcon/CreateUserIcon';
import LicenseGenerate from './subMneuIcon/licenseGenerate';
import MailSettingIcon from './subMneuIcon/MailSettingIcon';
import RemedyChildIcon from './subMneuIcon/RemedyChildIcon';
import IntelligentIcon from './subMneuIcon/IntelligentIcon';
import ManageCompanyIcon from './subMneuIcon/ManageCompanyIcon';
import ManageProjectIcon from './subMneuIcon/ManageProjectIcon';
import CreateCompanyIcon from './subMneuIcon/CreateCompanyIcon';
import CreateProjectIcon from './subMneuIcon/CreateProjectIcon';
import ManageTemplateIcon from './subMneuIcon/ManageTemplateIcon';
import SecuritySettingIcon from './subMneuIcon/SecuritySettingIcon';
import LicenseManagementIcon from './subMneuIcon/licenseManagementIcon';

/*
 *  function to map icon in left menu
 * */
export const manageIcon = (type) => {
  switch (type) {
    case 'SunIcon':
      return <SunIcon />;
    case 'SystemEvent':
      return <SystemEvent />;
    case 'IntelligentIcon':
      return <IntelligentIcon />;
    case 'Dropdown':
      return <Dropdown />;
    case 'LicenseTemp':
      return <LicenseTemp />;
    case 'LicenseGenerate':
      return <LicenseGenerate />;
    case 'SystemSetting':
      return <SystemSetting />;
    case 'CrashIcon':
      return <CrashIcon />;
    case 'RemedyChildIcon':
      return <RemedyChildIcon />;
    case 'MailSettingIcon':
      return <MailSettingIcon />;
    case 'UserSettingIcon':
      return <SecuritySettingIcon />;
    case 'ManageVulnerabilityIcon':
      return <ManageTemplateIcon />;
    case 'CreateProjectIcon':
      return <CreateProjectIcon />;
    case 'ManageProjectIcon':
      return <ManageProjectIcon />;
    case 'CreateUserIcon':
      return <CreateUserIcon />;
    case 'ManageUserIcon':
      return <ManageUserIcon />;
    case 'ManageCompanyIcon':
      return <ManageCompanyIcon />;
    case 'CreateCompanyIcon':
      return <CreateCompanyIcon />;
    case 'DashboardIcon':
      return <DashboardIcon />;
    case 'DomainIcon':
      return <DomainIcon />;
    case 'PersonIcon':
      return <PersonIcon />;
    case 'AssignmentIcon':
      return <AssignmentIcon />;
    case 'TransformIcon':
      return <TransformIcon />;
    case 'HistoryIcon':
      return <HistoryIcon />;
    case 'SettingsIcon':
      return <SettingsIcon />;
    case 'InsertDriveFileIcon':
      return <InsertDriveFileIcon />;
    case 'VpnKeyIcon':
      return <VpnKeyIcon />;
    case 'SecurityIcon':
      return <SecurityIcon />;
    case 'Edit':
      return <Edit />;
    case 'VerifiedUserIcon':
      return <VerifiedUserIcon />;
    case 'EventNoteIcon':
      return <EventNoteIcon />;
    case 'SyslogSettingsIcon':
      return <SyslogSettingsIcon />;
    case 'MlScanIcon':
      return <MlScanIcon />;
    case 'IntelligentModelIcon':
      return <IntelligentModelIcon />;
    case 'EventLogIcon':
      return <EventLogIcon />;
    case 'PlatformIcon':
      return <PlatformIcon />;
    case 'PlatformIconNew':
      return <PlatformIconNew />;
    case 'LicenseManagementIcon':
      return <LicenseManagementIcon />;
    case 'IPFirewallIcon':
      return <IPFirewallIcon />;
    case 'UserManagementIcon':
      return <UserManagementIcon />;
    default:
      return '';
  }
};

/*
 *  function to get current expanded or collapsed menu item state
 * */
export const hideOtherSubMenu = (item, currentState) => {
  const temp = {
    CLIENT: false,
    SOFTWARE: false,
    PLATFORM: false,
    SYSTEM_EVENT: false,
  };
  temp[item] = !currentState;
  return temp;
};
